const chatBotForms = [
  {
    orgSlug: "gala",
    uploadFormId: "Ek1KXsQF",
  },
  {
    orgSlug: "ie",
    uploadFormId: "hf9Ou7X2",
  },
  {
    orgSlug: "getboarded",
    uploadFormId: "UzMUt1QQ",
  },
  {
    orgSlug: "euruni",
    uploadFormId: "pLhDnvOx",
  },
];

export default chatBotForms;
